var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_325_365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0146 30.7226H5.19131C2.44185 30.7226 0.205078 28.4906 0.205078 25.7467V4.9759C0.205078 2.232 2.44185 0 5.19131 0H26.0146C28.7632 0 31 2.232 31 4.9759V25.7475C31 28.4914 28.7632 30.7226 26.0146 30.7226ZM10.6107 25.3985H10.6171V12.1464H6.4941V25.3985H10.61H10.6107ZM8.55282 10.3365C8.8663 10.3369 9.17678 10.2755 9.46648 10.1557C9.75617 10.036 10.0194 9.86021 10.2411 9.63854C10.4627 9.41688 10.6385 9.15366 10.7582 8.86396C10.878 8.57427 10.9394 8.26379 10.939 7.95031C10.9378 7.31783 10.686 6.71163 10.2387 6.2644C9.7915 5.81717 9.1853 5.56536 8.55282 5.5641C7.92003 5.56431 7.31321 5.81578 6.86575 6.26324C6.4183 6.71069 6.16683 7.31751 6.16662 7.95031C6.16683 8.5831 6.4183 9.18992 6.86575 9.63738C7.31321 10.0848 7.92003 10.3363 8.55282 10.3365ZM26.0384 25.3993V18.1342C26.0384 14.5644 25.2634 11.8182 21.0983 11.8182C19.096 11.8182 17.7519 12.9151 17.1994 13.9564H17.1438V12.1464H13.1957V25.3985H17.3115V18.8408C17.3115 17.1112 17.6398 15.438 19.7836 15.438C21.8916 15.438 21.9226 17.4156 21.9226 18.9521V25.3985H26.0384V25.3993Z",
    fill: "#E3E3E3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_325_365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.0a1fed9d9aa8b1d1618b3e75ac5a99be.svg";
export { ForwardRef as ReactComponent };